module.exports = "assets/img/owners.jpg";